import React, { useContext, useState } from "react";
import { Grid, Form, Header, Icon, Button, Segment } from "semantic-ui-react";
import FoCloseStatusContext from "./FoStatusContext";

function FoStatusFilters() {
  const ctx = useContext(FoCloseStatusContext);
  const [isExpanded, setIsExpanded] = useState(false);
  const [claimNumber, setClaimNumber] = useState("");

  const handleRoleChange = (_: any, { value }: any) => {
    ctx.filters.setUserRole(value as string);
    const selected = ctx.options.userRoles.find((role) => role.value === value);
    ctx.filters.setReportee(selected?.reportee || []);
    ctx.filters.setUser("");
  };

  const handleStateChange = (_: any, { value }: any) => {
    ctx.filters.setStates(value as string);
    ctx.filters.setDistrict("");
  };

  const clearAllFilters = () => {
    ctx.filters.setUserRole("");
    ctx.filters.setUser("");
    ctx.filters.setReportee([]);
    ctx.filters.setStates("");
    ctx.filters.setDistrict("");
    ctx.filters.setDistrictOptions([...ctx.filters.AllDistrictS]);
    setClaimNumber("");
    ctx.filters.setClaimNumber("");
  };

  return (
    <Segment>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Header as="h4">Filter</Header>
        <Icon
          name="arrow alternate circle down outline"
          size="large"
          style={{ cursor: "pointer" }}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>

      {isExpanded && (
        <Grid columns={5}>
          <Grid.Row>
            <Grid.Column>
              <Form.Dropdown
                label="User Role"
                search
                selection
                clearable
                placeholder="Select User Role"
                options={ctx.options.userRoles}
                value={ctx.filters.userRole}
                onChange={handleRoleChange}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Dropdown
                label="User"
                search
                selection
                clearable
                placeholder={
                  ctx.filters.userRole ? "Select User" : "Select User Role first"
                }
                disabled={!ctx.filters.userRole}
                options={ctx.options.user}
                value={ctx.filters.user}
                onChange={(_, { value }) => ctx.filters.setUser(value as string)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Dropdown
                label="Insured State"
                search
                selection
                clearable
                placeholder="Select State"
                options={ctx.options.states}
                value={ctx.filters.states}
                onChange={handleStateChange}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Dropdown
                label="Insured District"
                search
                selection
                clearable
                placeholder="Select District"
                options={ctx.options.districts}
                value={ctx.filters.district}
                onChange={(_, { value }) =>
                  ctx.filters.setDistrict(value as string)
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Input
                label="Claim Number"
                placeholder="Enter Claim Number"
                value={claimNumber}
                onChange={(_, { value }) => {
                  setClaimNumber(value);
                  // clearing the box clears the filter immediately
                  if (value === "") ctx.filters.setClaimNumber("");
                }}
                onKeyDown={(e: { key: string }) => {
                  if (e.key === "Enter") ctx.filters.setClaimNumber(claimNumber);
                }}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Button type="button" onClick={clearAllFilters}>
                Clear
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </Segment>
  );
}

export default FoStatusFilters;
